<core-helpers-box-list-item
    [close]="remove"
    (onCloseClick)="onRemove.emit(file)"
    [mainText]="mainText"
    (onMainTextClick)="onSelect.emit(file)"
    [actionText]="downloadText "
    (onActionTextClick)="downloadAction()"
    [rightText]="file.extension"
></core-helpers-box-list-item>
